import { useEffect } from "react";

const useOnResize = (handleResize) => {
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
};

export default useOnResize;
